import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { useCompareFormData } from 'hooks/useCompareFormData';
import { EditGameContext, IEditGameContext } from 'modules/Entertainment/Games/EditGame/editGameState/editGameContext';
import classNames from 'classnames';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		name,
		IDSelectedDeveloper,
		IDSelectedCategory,
		versionCode,
		versionName,
		applicationId,
		description,
		IDsSelectedLanguages,
		translations,
		iconFileId,
		iconFilePath,
		gameFileData,
		initialFormData,
	} = useContext<IEditGameContext>(EditGameContext);
	const containerClasses = classNames(style.container, {
		[style.visible]:
			name ||
			IDSelectedDeveloper ||
			IDSelectedCategory ||
			IDsSelectedLanguages.length ||
			versionName ||
			versionCode ||
			applicationId ||
			description ||
			iconFileId ||
			gameFileData.fileId,
	});

	const compareGameFile = () => {
		if (gameFileData.fileId) {
			return gameFileData.fileId; // if uploaded new file
		}
		return { fileId: '', fileName: '', fileHash: null }; // if no file
	};

	const currentFormData = {
		IDSelectedDeveloper,
		IDSelectedCategory,
		applicationId,
		name,
		versionCode,
		versionName,
		description,
		IDsSelectedLanguages,
		translations,
		gameFileData: compareGameFile(),
		iconFilePath: iconFileId || iconFilePath || null,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}
					data-test="cancelButton">
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button
					className={style.saveBtn}
					theme="primaryBlue"
					type="submit"
					disabled={isEqualFormData}
					data-test="saveButton">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
